<template>
	<div class="w-100">
    <form>
      <div class="my-3 pb-1">
        <div class="row slim-grid-row mb-3">
					<!-- TITLE -->
        	<div class="col-lg-2 col-12 mb-3 mb-lg-0">
        		<div class="">
              <p 
              	class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" 
              	v-show="show_label.title" 
              	:class="{'label-active':show_label.title}">
              	{{$t('hotel.visitor-detail.title')}}
              </p>
              <v-select 
	              type="text" 
	              class="general-select-border body-2-2 text-14 mb-1 font-semibold"
	              :class="{'error':error.title}"
	              :placeholder="$t('hotel.visitor-detail.title')" 
	              :clearable="false"
	              @focus="toggleLabel('focus', 'title')" 
	              @blur="toggleLabel('blur', 'title')" 
	              :options="options_title" 
	              v-model="form.title"
	              @input="submit()"></v-select>
            	<p class="mb-0 text-danger body-2 text-12 font-regular delay" v-if="error.title">{{$t('hotel.visitor-detail.title-warning')}}</p>
            </div>
        	</div>

					<!-- FIRST NAME -->
					<div class="col-lg-5 col-6">
            <p class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" 
            v-show="show_label.first_name" 
            :class="{'label-active':show_label.first_name}">{{$t('hotel.visitor-detail.first-name')}}</p>
            <input 
	            type="text" 
	            class="form-control body-2-2 text-14 mb-1 font-semibold" 
	            :class="{'error':error.first_name}"
	            :placeholder="$t('hotel.visitor-detail.first-name')" 
	            @focus="toggleLabel('focus','first_name')" 
	            @blur="toggleLabel('blur','first_name')" 
	            v-model="form.first_name"
	            @input="submit()" />
							<p class="mb-0 text-danger body-2 text-12 font-regular delay" v-if="error.first_name">{{$t('hotel.visitor-detail.first-name-warning')}}</p>
            	<p class="mb-0 body-2 font-regular text-12 sub-label" v-else>{{$t('hotel.visitor-detail.name-desc')}}</p>
          </div>

					<!-- LAST NAME -->
          <div class="col-lg-5 col-6">
            <p class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" v-show="show_label.last_name" :class="{'label-active':show_label.last_name}">{{$t('hotel.visitor-detail.last-name')}}</p>
              <input 
              	type="text" 
              	class="form-control body-2-2 text-14 mb-1 font-semibold" 
              	:placeholder="$t('hotel.visitor-detail.last-name')" 
              	@focus="toggleLabel('focus','last_name')" 
              	@blur="toggleLabel('blur','last_name')" 
              	v-model="form.last_name"
              	@input="submit()"/>
          </div>
				</div>
				<div class="row slim-grid-row mb-3">
					<!-- COUNTRY CODE -->
					<div class="col-lg-2 col-4" :class="{'col-md-4':type != 'customer'}">
            <p class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" v-show="show_label.country_code" :class="{'label-active':show_label.country_code}">{{$t('hotel.visitor-detail.country-code')}}</p>
              <v-select 
              	class="general-select-border body-2-2 text-14 mb-1" 
              	:class="{'error':error.dial_code}"
              	:placeholder="$t('hotel.visitor-detail.country-code')" 
              	label="dial_code"
              	:clearable="false"
              	@focus="toggleLabel('focus','dial_code')" 
              	@blur="toggleLabel('blur','dial_code')" 
              	:options="country" 
              	v-model="dial_code"
              	@input="submit()">
              	<template #option="{ dial_code, code }">
									<span class="body-2 mb-0">{{code}} </span>|<span class="body-2 text-color-dark"> {{dial_code}}</span>
								</template>
              </v-select>
            	<p class="mb-0 text-danger body-2 text-12 font-regular delay" v-if="error.dial_code">{{$t('hotel.visitor-detail.country-code-warning')}}</p>
          </div>

					<div class="col-lg-10 col-8">
						<div class="row slim-grid-row">
							<!-- PHONE NUMBER  -->
							<div class="col-lg-4 col-12" :class="{'col-md-8':type != 'customer'}">
								<p class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" v-show="show_label.phone_number" :class="{'label-active':show_label.phone_number}">{{$t('hotel.visitor-detail.phone-number')}}</p>
									<input 
										type="text" 
										class="form-control body-2-2 text-14 mb-1 font-semibold" 
										:class="{'error':error.phone_number}"
										:placeholder="$t('hotel.visitor-detail.phone-number')" 
										@focus="toggleLabel('focus','phone_number')" 
										@blur="toggleLabel('blur','phone_number')" 
										v-model="form.phone_number"
										@input="submit()" />
									<p class="mb-0 text-danger body-2 text-12 font-regular delay" v-if="error.phone_number">{{$t('hotel.visitor-detail.phone-number-warning')}}</p>
									<!-- <p class="mb-0 text-danger body-2 text-12 font-regular delay" v-if="!errorPhone && form.phone_number != ''">{{$t("hotel.visitor-detail.Your phone number")}} ({{form.phone_number}}) {{$t("hotel.visitor-detail.is invalid")}}</p> -->
							</div>
		
							<!-- EMAIL -->
							<div class="col-lg-4 col-12 mt-3 mt-lg-0">
								<p class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" v-show="show_label.email" :class="{'label-active':show_label.email, 'text-danger':!error_email}">{{$t('hotel.visitor-detail.email')}}</p>
									<input 
										type="email" 
										class="form-control body-2-2 text-14 mb-1 font-semibold" 
										:class="{'error':error.email || !error_email}"
										:placeholder="$t('hotel.visitor-detail.email')" 
										@focus="toggleLabel('focus','email')" 
										@blur="toggleLabel('blur','email')" 
										v-model="form.email"
										@input="submit()" />
									<p class="mb-0 text-danger body-2 text-12 font-regular delay" v-if="!error_email">{{$t('hotel.visitor-detail.email-warning')}}</p>
									<p class="mb-0 body-2 font-regular text-12 sub-label" v-else>{{$t('hotel.visitor-detail.email-desc')}}</p>
							</div>
						</div>
					</div>
				</div>
				<div class="row slim-grid-row mb-3">
					<!-- COUNTRY -->
					<div class="col-lg-6 col-12 mb-3 mb-lg-0">
            <p class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" v-show="show_label.country" :class="{'label-active':show_label.country}">{{$t('hotel.visitor-detail.country')}}</p>

              <v-select 
                class="general-select-border body-2-2 text-14 mb-1" 
                :class="{'error':error.country}"
                :placeholder="$t('hotel.visitor-detail.country')" 
                label="name"
                :clearable="false"
                @focus="toggleLabel('focus','country')" 
                @blur="toggleLabel('blur','country')" 
                :options="country" 
                v-model="country_selected"
                @input="submit()" />

              <!-- <input 
                type="text" 
                class="form-control body-2-2 text-14 mb-1 font-semibold" 
                :class="{'error':error.country}"
                :placeholder="$t('hotel.visitor-detail.country')" 
                @focus="toggleLabel('focus','country')" 
                @blur="toggleLabel('blur','country')" 
                v-model="country_selected"
                @input="submit()"
                @change="submit()"> -->
              <!-- <p class="mb-0 text-danger body-2 text-12 font-regular delay" v-if="error.country">{{$t('hotel.visitor-detail.country-warning')}}</p> -->
              <!-- <p class="mb-0 body-2 font-regular text-12 sub-label" v-else>{{$t('hotel.visitor-detail.country')}}</p> -->
          </div>

					<!-- NATIONALITY -->
					<div class="col-lg-6 col-12">
            <p class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" v-show="show_label.nationality" :class="{'label-active':show_label.nationality}">{{$t('hotel.visitor-detail.nationality')}}</p>

              <v-select 
                class="general-select-border body-2-2 text-14 mb-1" 
                :class="{'error':error.nationality}"
                :placeholder="$t('hotel.visitor-detail.nationality')" 
                label="name"
                :clearable="false"
                @focus="toggleLabel('focus','nationality')" 
                @blur="toggleLabel('blur','nationality')" 
                :options="country" 
                v-model="nationality_selected"
                @input="submit()" />

              <!-- <input 
                type="text" 
                class="form-control body-2-2 text-14 mb-1 font-semibold" 
                :class="{'error':error.country}"
                :placeholder="$t('hotel.visitor-detail.country')" 
                @focus="toggleLabel('focus','country')" 
                @blur="toggleLabel('blur','country')" 
                v-model="country_selected"
                @input="submit()"
                @change="submit()"> -->
              <!-- <p class="mb-0 text-danger body-2 text-12 font-regular delay" v-if="error.country">{{$t('hotel.visitor-detail.country-warning')}}</p> -->
              <!-- <p class="mb-0 body-2 font-regular text-12 sub-label" v-else>{{$t('hotel.visitor-detail.country')}}</p> -->
          </div>
        </div>
      </div>
      <!-- <div class="pb-1" :class="{'mt-0':type != 'customer'}" style="margin-top: 1rem">
        <div class="row slim-grid-row">
          <div class="col-12" :class="{'col-md-12 mt-3':type != 'customer'}">
            <p class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" v-show="show_label.address" :class="{'label-active':show_label.address}">{{$t('hotel.visitor-detail.address')}}</p>
              <textarea 
                type="text"
                rows="3" 
                class="form-control body-2-2 text-14 mb-1 font-semibold py-2" 
                :class="{'error':error.address}"
                :placeholder="$t('hotel.visitor-detail.address')" 
                @focus="toggleLabel('focus','address')" 
                @blur="toggleLabel('blur','address')" 
                v-model="form.address"
                @input="submit()" /></textarea>
              <p class="mb-0 text-danger body-2 text-12 font-regular delay" v-if="error.address">{{$t('hotel.visitor-detail.address-warning')}}</p>
              <p class="mb-0 body-2 font-regular text-12 sub-label" v-else>{{$t('hotel.visitor-detail.address')}}</p>
          </div>
        </div>
      </div> -->
    </form>
	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
	import country from "@/data/country"
	import { parsePhoneNumber,parsePhoneNumberFromString,ParseError  } from 'libphonenumber-js'
	export default{
		props:{
			type :{
				type: String,
				default: 'customer'
			},
			radio_button_show: {
				type: ''
			},
			size: {
				type: Boolean,
        default: false
			},
			error_check: {
				type: Boolean,
				default: false
			},
		},
		data(){
			return{
        contact_detail: false,
			 	show_label: {
		      first_name: false,
		      last_name: false,
		      title: false,
		      country_code: false,
		      phone_number: false,
		      email: false,
          dial_code: false,
          country: false,
					nationality: false
		    },
		    error: {
		      first_name: false,
		      last_name: false,
		      title: false,
		      country_code: false,
		      phone_number: false,
		      email: false,
          dial_code: false,
          country: false,
					nationality: false
		    },
		    form: {
		      first_name: '',
		      last_name: '',
		      phone_number: '',
		      email: '',
		      title: '',
          country: '',
					nationality: ''
		    },
        dial_code: {},
        country: country,
        nationality_selected: {},
		    options_title: ['Mr','Mrs','Ms'],
			}
		},
		computed:{
			data(){
				return (this.type == 'customer') ? this.getBeCart().customer_details : this.getBeCart().visitor_details
			},
      error_email(){
        let display = true
        if (this.error_check) {
          if (this.getIsCartContactEmail()) {
            display = true
          }else{
            display = false
          }
        }
        return display
      },
      errorPhone(){
        let display = false
        var numbers = /^[-+]?[0-9]+$/;
        if(this.form.phone_number.match(numbers))
        {
          display = true
        }else{
          display = false
        }
        return display
      }
		},
    watch:{
      error_check(){
        for(let label in this.error){
          this.toggleLabel("blur",label)
        }
      }
    },
    mounted(){
      this.fillData()
      for(let label in this.show_label){
        this.toggleLabel("blur",label)
      }
    },
		methods:{
			...mapGetters(['getBeCart','getIsCartContactEmail','getIsCartVisitorEmail']),
			...mapMutations(['setBeCustomer','setBeVisitor']),
			fillData(){
				this.form = Object.assign({}, this.data)
				if (this.data.phone_number == '#' || this.data.phone_number == '' || this.data.phone_number == undefined || this.data.phone_number == null) {
					this.form.phone_number = ''
	    		this.dial_code = this.country.find(x => x.code == 'ID')
				}else{
					const phone_parsed = parsePhoneNumberFromString(this.data.phone_number)
					if (phone_parsed == undefined || typeof(phone_parsed) == 'undefined') {
		    		this.error.phone_number = 'your phone number ('+this.data.phone_number+') is invalid'
		    		this.dial_code = this.country.find(x => x.code == 'ID')
					}else{
						this.dial_code = this.country.find(x => x.code == phone_parsed.country)
						this.form.phone_number = phone_parsed.nationalNumber
					}
				}

        let params_country = this.form.country == '' ? 'Indonesia' : this.form.country
        this.country_selected = this.country.find(x=>x.name == params_country)
			},
      toggleLabel(data, id){
        if (data == 'focus') {
          this.show_label[id] = true  
        }else{
        	if (this.data[id] == '' && this.error_check) {
	      		this.error[id] = true
	      	}else{
	      		this.error[id] = false
	      	}
        	if(id == 'dial_code'){
        		this.show_label[id] = (Object.keys(this.dial_code).length == 0) ? false :  true
        	}else if(id == 'country'){
            this.show_label[id] = (Object.keys(this.country_selected).length == 0) ? false :  true
          }else{
          	this.show_label[id] = (this.form[id] == '') ? false :  true 
        	}
        }
      },
      submit(){
        this.form.country = this.country_selected.name
      	let params = Object.assign({}, this.form)
      	if(this.form.phone_number != ''){
    			params.phone_number = this.dial_code.dial_code+this.form.phone_number
    		}
    		if(this.type == 'customer'){
    			this.setBeCustomer(params)
    		}else{
    			this.setBeVisitor(params)
    		}
      },
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/hotel/be/desktop/contactForm.vue